import React, { ReactNode } from "react";
import TopHead from "@/components/TopHead";
import Footer from "@/components/Footer";

interface LayoutProps {
  children: ReactNode;
}

const HomeLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-w-screen min-h-screen">
      <TopHead />
      {children}
      <Footer />
    </div>
  );
};

export default HomeLayout;
